/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {


  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $('[data-toggle="copter--navbar"]').on('click',function() {
          $('.copter--navbar, .copter--hamburger').toggleClass('is-active');
        });

        // $(".copter--page").fitVids();

        if ($('.rellax').length) {
          var rellax = new Rellax('.rellax', {
            center: true
          });
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        //
        var options = {
          // Optional parameters
          direction: 'horizontal',
          loop: true,
          preloadImages: false,
          lazy: true,
          centeredSlides: true,
          width: 768,
          spaceBetween: 8,
          slidesOffsetBefore: (($(window).width() - 768) / 2),
          slidesPerView: 1,
          autoplay: {
            delay: 3500,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            // when window width is <= 320px
            575: {
              width: 335,
              slidesOffsetBefore: (($(window).width() - 335) / 2),
              spaceBetween: 8,
              slidesPerView: 1
            },
            768: {
              width: 500,
              slidesOffsetBefore: (($(window).width() - 500) / 2),
              spaceBetween: 8,
              slidesPerView: 1
            },
            1200: {
              width: 640,
              slidesOffsetBefore: (($(window).width() - 640) / 2),
              spaceBetween: 8,
              slidesPerView: 1
            }
          }
        };

        var mySwiper = new Swiper('.swiper-container', options);


        $('.swiper-container').on('hover',function() {
            mySwiper.autoplay.stop();
        }, function() {
            mySwiper.autoplay.start();
        });


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
